import { useQuery } from "@tanstack/react-query";
import { ToastService } from "@shared/lib/services";
import { useEffect } from "react";

import { BackednResponse } from "@shared/lib/types";
import { IBucketFacets } from "@shared/lib/types/influencer";
import { BucketService } from "../services/bucket.service";
import { BUCKET_FACETS_QUERY_KEY } from "../constants";

export function useGetBucketFacets() {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<IBucketFacets>
  >({
    queryKey: [BUCKET_FACETS_QUERY_KEY],
    queryFn: async () => await BucketService.getBucketFacets(),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    facets: data?.data || {},
    isError,
    isFetching: isLoading,
  };
}
